import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  statusText: {
    maxWidth: '450px',
  },
}));

export default useStyles;
